import React from "react";
import { Job } from "@scrile/api-provider/dist/api/QuestionaryInfoProvider";
import useViewController from "./viewController";
import BaseButton from "../../../../components/BaseButton";
import BaseForm from "../../../../components/BaseForm";
import BaseIcon from "../../../../components/BaseIcon";
import { useTranslation } from "../../../../locales";
import "./style.scss";

interface Props {
  job?: Job;
  jobIndex: number;
  onChange: (jobValues: Job) => void;
  onDelete?: () => void;
  setCheckValidation: (key: number, cb: () => boolean) => void;
}

export default function ProfessionalFields({ job, jobIndex, onChange, onDelete, setCheckValidation }: Props) {
  const { t } = useTranslation();
  const { fields, values, errors, setErrors, onChangeHandler } = useViewController({
    jobIndex,
    jobValues: job,
    onChange,
    setCheckValidation,
  });

  return (
    <BaseForm
      className="experience-view-field"
      fields={fields}
      values={values}
      onChange={onChangeHandler}
      errors={errors}
      setErrors={setErrors}
    >
      {onDelete && (
        <BaseButton className="experience-view-field__button" negativeOpacity onClick={onDelete}>
          <BaseIcon size="20" className="mr-1">
            close
          </BaseIcon>
          {t("Delete")}
        </BaseButton>
      )}
    </BaseForm>
  );
}
